import fasilitas1 from "./1-2.webp";
import fasilitas2 from "./2-3.webp";
import fasilitas3 from "./3.webp";
import fasilitas4 from "./4-1.webp";
import fasilitas5 from "./5-2.webp";
import fasilitas6 from "./6-3 (1).webp";
import fasilitas7 from "./7-1.webp";
import fasilitas8 from "./8-1.webp";
import fasilitas9 from "./9-3.webp";
import fasilitasbaru1 from "./fasilitasbaru (1).jpeg";
import fasilitasbaru3 from "./fasilitasbaru (3).jpeg";
import fasilitasbaru4 from "./fasilitasbaru (4).jpeg";
import fasilitasbaru5 from "./fasilitasbaru (5).jpeg";
import fasilitasbaru6 from "./fasilitasbaru (6).jpeg";
import fasilitasbaru7 from "./fasilitasbaru (7).jpeg";
import fasilitasbaru8 from "./fasilitasbaru (8).jpeg";
import fasilitasbaru9 from "./fasilitasbaru (9).jpeg";
import fasilitasbaru10 from "./fasilitasbaru (10).jpeg";

const fasilitasimg = [
  fasilitasbaru1,
  fasilitasbaru3,
  fasilitasbaru4,
  fasilitasbaru5,
  fasilitasbaru6,
  fasilitasbaru7,
  fasilitasbaru8,
  fasilitasbaru9,
  fasilitasbaru10,
  fasilitas1,
  fasilitas2,
  fasilitas3,
  fasilitas4,
  fasilitas5,
  fasilitas6,
  fasilitas7,
  fasilitas8,
  fasilitas9,
];

export default fasilitasimg;
